<template>
  <div class="py-10">
    <button @click="print" class="block float-right uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded">
      Export Pdf
    </button>
    <label class="inline-flex items-center mt-3">
      <input type="radio" class="p-2 form-radio h-4 w-4" v-model="finished" value />
      <span class="ml-2 pr-2 text-gray-700">Te gjitha</span>
    </label>
    <label class="inline-flex items-center mt-3">
      <input type="radio" class="p-2 form-radio h-4 w-4" value="0" v-model="finished" id />
      <span class="ml-2 pr-2 text-gray-700">Te paperfunduara</span>
    </label>
    <label class="inline-flex items-center mt-3">
      <input type="radio" class="p-2 form-radio h-4 w-4" value="1" v-model="finished" id />
      <span class="ml-2 pr-2 text-gray-700">Te perfunduara</span>
    </label>
    <div class="flex py-4">
      <button
        @click="filterTasks"
        class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
      >Filtro</button>
    </div>
    <div class="align-middle inline-block min-w-full overflow-hidden border border-gray-400" id="print">
      <p class="font-semibold p-2">Last Update: {{ updated }}</p>
      <table class="min-w-full">
        <thead>
          <tr>
            <th
              class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >NR</th>
            <th
              class="px-2 py-2 border w-2/6 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >NAME</th>
            <th
              class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >STATUS</th>
            <th
              class="px-2 py-2 border w-2/6 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >KOMENT</th>
            <th
              class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >TIME</th>
            <th
              class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >USER</th>
            <th
              class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-800 uppercase tracking-wider"
            >TYPE</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr
            v-for="(tasks, index) in screenTasks"
            :key="index.id"
            :class="
              tasks.status === 'K'
                ? 'bg-green-200'
                : '' || tasks.status === 'P'
                ? 'bg-orange-400'
                : '' || tasks.status === null
                ? 'bg-red-200'
                : '' || tasks.status === '0'
                ? 'bg-red-400'
                : ''
            "
          >
            <td class="border border-gray-400">{{ index + 1 }}</td>
            <td class="border border-gray-400">
              <span
                :class="
                  tasks.name.substring(0, 3) === '!!!'
                    ? 'text-red-600 font-semibold'
                    : ''
                "
              >{{ tasks.name }}</span>
            </td>
            <td class="border border-gray-400">{{ tasks.status }}</td>
            <td class="border border-gray-400">{{ tasks.comment }}</td>
            <td class="border border-gray-400">{{ tasks.time }}</td>
            <td class="border border-gray-400">{{ tasks.user }}</td>
            <td class="border border-gray-400">{{ tasks.type }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <button
      @click="back"
      class="block my-4 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
    >Kthehu</button>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      screenTasks: [],
      counter: 1,
      updated: moment().format("hh:mm a"),
      finished: null
    };
  },
  created() {
    this.getScreenTasks();
  },
  methods: {
    getScreenTasks() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/detyrat-ekran`)
        .then(response => {
          this.screenTasks = response.data.detyrat;
          // console.log(response.data.detyrat);
        })
        .catch(error => console.log(error))
        .finally((this.updated = moment().format("hh:mm a")));
      this.waitForTasks();
    },
    waitForTasks() {
      setTimeout(() => {
        this.getScreenTasks();
      }, 300000);
    },
    back() {
      return this.$router.push("/excel");
    },
    filterTasks() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      this.url = `${process.env.VUE_APP_API}/excel/detyrat-ekran`;

      if (this.finished) {
        this.url += `?done=${this.finished}`;
      }
      
      axios.get(`${this.url}`).then(response => {
        this.screenTasks = response.data.detyrat;
        // console.log(response);
      });
    },
    print() {
      this.$htmlToPaper("print");
    },
  }
};
</script>

<style></style>
